
import { Database } from "@/integrations/supabase/types";
import { Camera, Filter, Monitor, Battery, Anchor, HardDrive, Wrench, Lightbulb, Grip, Package, Sparkles } from "lucide-react";

export type GearCategory = Database["public"]["Enums"]["gear_category"];

export interface GearItem {
  id: string;
  name: string;
  category: GearCategory;
  quantity: number;
  cost_per_unit: number;
  notes: string | null;
  vendor_id?: string | null;
  vendors?: { name: string } | null;
  days_needed?: number;
  department?: "camera" | "ge";
}

export interface ProjectBudget {
  camera_budget: number;
  ge_budget: number;
  total_budget: number;
  camera_spent: number;
  ge_spent: number;
}

// Prioritize camera categories by listing them first
export const CAMERA_CATEGORIES: GearCategory[] = [
  "Cameras",
  "Lenses",
  "Monitoring",
  "Camera Support",
  "Filters",
  "Camera AKS",
  "Power",
  "Media",
  "Other"
];

export const GE_CATEGORIES: GearCategory[] = [
  "Lighting Fixtures",
  "Grip",
  "Electric",
  "Grip Package",
  "Specialty Items"
];

export const categoryIcons = {
  "Cameras": Camera,
  "Lenses": Camera,
  "Filters": Filter,
  "Monitoring": Monitor,
  "Power": Battery,
  "Camera Support": Anchor,
  "Media": HardDrive,
  "Camera AKS": Wrench,
  "Lighting Fixtures": Lightbulb,
  "Grip": Grip,
  "Electric": Lightbulb,
  "Grip Package": Package,
  "Specialty Items": Sparkles,
  "Other": Package
};

// Explicitly check that all categories are valid
const ALL_CATEGORIES = [...CAMERA_CATEGORIES, ...GE_CATEGORIES];
type TypeCheck = (typeof ALL_CATEGORIES)[number] extends GearCategory ? true : false;
const _typeCheck: TypeCheck = true;
